export type BrowserDisplayMetrics = Readonly<{
  screenWidth: number;
  screenHeight: number;
  windowWidth: number;
  windowHeight: number;
  viewportWidth: number;
  viewportHeight: number;
  pixelRatio: number;
}>;

// Called only by session creation. No resize listeners or periodic reporting.
export function captureBrowserDisplayMetrics(): BrowserDisplayMetrics | undefined {
  if (typeof window === 'undefined') return undefined;
  const display = {
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    windowWidth: window.outerWidth,
    windowHeight: window.outerHeight,
    viewportWidth: window.innerWidth,
    viewportHeight: window.innerHeight,
    pixelRatio: window.devicePixelRatio,
  };
  if (
    !Number.isFinite(display.pixelRatio) ||
    display.pixelRatio <= 0 ||
    display.pixelRatio > 32 ||
    Object.entries(display).some(
      ([key, value]) =>
        key !== 'pixelRatio' && (!Number.isInteger(value) || value < 0 || value > 100000),
    )
  )
    return undefined;
  return display;
}
